import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './ArtistShowcase.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function ArtistPhoto({ src, alt }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return <div className="artist-img artist-img--fallback">FOTO ARTIS</div>;
  }
  return (
    <img
      className="artist-img"
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
    />
  );
}

export default function ArtistShowcase({ eyebrow = 'Roster', title = 'Artis Kami' }) {
  const [artists, setArtists] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/artists/public?limit=5`)
      .then((res) => {
        if (mounted) setArtists(res.data.data || []);
      })
      .catch(() => {
        if (mounted) setArtists([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!loading && artists.length === 0) return null;

  return (
    <section className="artist-showcase reveal" id="artists">
      <div className="artist-showcase__header">
        <div>
          <span className="artist-showcase__eyebrow">{eyebrow}</span>
          <h2 className="artist-showcase__title">{title}</h2>
        </div>
        <Link to="/artists" className="artist-showcase__see-all">Lihat Semua Artis →</Link>
      </div>

      {loading ? (
        <div className="artist-showcase__empty">Memuat artis...</div>
      ) : (
        <>
          <div className="artist-showcase__scroll-hint">👉 Geser untuk lihat semua artis</div>
          <div className="artists">
            {artists.map((artist, i) => (
              <a href={`/artists/${artist.slug}`} className="artist-card" key={artist.id}>
                <ArtistPhoto src={artist.photo_url} alt={artist.name} />
                <div className="artist-index">{String(i + 1).padStart(2, '0')}</div>
                <div className="artist-info">
                  <div className="artist-name">{artist.name}</div>
                  {artist.genre && <div className="artist-genre">{artist.genre.toUpperCase()}</div>}
                </div>
              </a>
            ))}
          </div>
        </>
      )}
    </section>
  );
}
